/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import PlusIcon from "./PlusIcon";
import TasksStatusWidget from "../Tasks/TasksStatusWidget";
import TaskModal from "../Settings/Modal/TaskModal";
import GroupByDropdown from "../../Components/common/GroupByDropdown";
import { getKeyboardSymbol, isMac } from "../../Components/action/utilities";
import { CmdKeyIcon } from "../../Components/LandingHeader/Feedback/icons/Icons";

const AddTaskStatic = React.memo(({taskStatus = null, currentPage = "home", className = "", groupDate = null, isTodayPage = false, groupsDropdown = false, groupKey = null, classNames = "", separator = true, onHide = null, totalTaskCount = null, onlyRecurringTasks = false}) => {
  const theme = useSelector(state => state.theme.theme);
  const [openTaskModal, setOpenTaskModal] = useState(null);
  const settings = useSelector(state => state.settings.settings)

  return (
    <>
        <div className={`type-header relative ${classNames} ${separator ? 'hr-line' : ''}`}>
            <form 
                css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
                className="add-task-static"
                >
                <div className={`filed-type ${className} w-full flex border-b border-gray-200 items-center relative !p-5 bg-white dark:bg-black`} style={{ borderBottom: '0 !important' }} 
                css={{
                        input: {
                        color: theme == "dark" ? "white !important" : ""
                        }
                    }}>
                    <div style={{ position: 'relative', overflowY: 'visible' }}>
                    <div style={{ fontSize: '16px', height: '18px' }}>
                        <div style={{
                            position: 'relative',
                            boxSizing: 'border-box',
                            width: '100%',
                            color: 'transparent',
                            overflow: 'hidden',
                            whiteSpace: 'pre',
                            border: '1px solid transparent',
                            textAlign: 'start'
                        }}> </div>
                        <input
                        type="text"
                        placeholder="Add a Task..."
                        className="dark:placeholder:text-white1 add-task-input active"
                        readOnly={true}
                        css={{
                            display: 'block',
                            width: '100%',
                            position: 'absolute',
                            margin: '0px',
                            top: '0px',
                            left: '0px',
                            boxSizing: 'border-box',
                            backgroundColor: 'transparent',
                            fontFamily: 'inherit',
                            fontSize: 'inherit',
                            letterSpacing: 'inherit',
                            border: '0px'
                        }}
                        onClick={(e) => {
                            e.preventDefault()
                            setOpenTaskModal({currentPage, groupDate})
                        }}
                        />
                    </div>
                    </div>
                    <span className="add-sqc-static">
                        <PlusIcon />
                    </span>
                    <div className="press-option">
                        {
                            typeof settings.keyboardShortcuts == 'undefined' || settings?.keyboardShortcuts?.addTask?.length > 0
                            ?
                            <span className="shortcut">{ settings?.keyboardShortcuts?.addTask?.length > 0 ? settings?.keyboardShortcuts?.addTask.map(item => getKeyboardSymbol(item, true)).join(' ') : (isMac ? <><CmdKeyIcon opacity={0.7} width={12} height={12} /> + Enter</> : ['Ctrl', 'Enter'].map(item => getKeyboardSymbol(item, true)).join(' '))}</span>
                            :
                            null
                        }
                    </div>
                </div>
                {
                    isTodayPage && taskStatus && <TasksStatusWidget styles={groupsDropdown ? {marginRight: '10px'} : {}} taskStatus={taskStatus} totalTaskCount={totalTaskCount} />
                }
                {
                    groupsDropdown
                    &&
                    <GroupByDropdown />
                }
                
            </form>
        </div>
        {
            openTaskModal
            &&
            <TaskModal
                groupKey={groupKey}
                show={true}
                data={null}
                onlyRecurringTasks={onlyRecurringTasks}
                currentPage={openTaskModal.currentPage}
                groupDate={openTaskModal.groupDate}
                onHide={(data = null) => {
                    onHide && onHide(data);
                    setOpenTaskModal(null)
                }}
            />
        }
    </>
  );
});

export default AddTaskStatic;